import "./FooterStyle.css";
import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="top">
        <div>
          <h1>Luis Marquez</h1>
          <p>Software Developer</p>
        </div>
        <div>
          <a
            href="https://www.linkedin.com/in/luis-marquez-49556333/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
          <a
            href="https://github.com/Lmarquez1983"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-github"></i>
          </a>
        </div>
      </div>

      <div className="bottom">
        <div>
          <h4>Projects</h4>
          <a href="/">Changelog</a>
          <a href="/">Status</a>
          <a href="/">Licenses</a>
        </div>
        <div>
          <h4>Community</h4>
          <a href="/">Programming</a>
          <a href="/">Prompt Engineering</a>
          <a href="/">Github</a>
        </div>
        <div>
          <h4>Contact</h4>
          <a href="/">Best way to approach</a>
          <a href="/">Resume</a>
          <a href="/">Experience</a>
        </div>
        <div>
          <h4>Help</h4>
          <a href="/">Support</a>
          <a href="/">Troubleshooting</a>
          <a href="/">Contractor</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
